import styled from "styled-components";

export const FiltroCascadaContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 36px;
  width: max-content;
  user-select: none;

  label {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    cursor: pointer;
  }
  .FiltroCascada-checkbox {
    height: 30px;
    accent-color: var(--color-latex30);
    width: 30px;
  }
`;
export const FiltroCascadaHeader = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: 20px;
  color: var(--color-latex10);
`;
export const FiltroCascadaBody = styled.div`
  display: flex;
  gap: 16px;
`;
export const FiltroCascadaScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 200px;
`;

export const FiltroCascadaElementos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 18px;
  gap: 18px;
  font-size: 20px;
  padding-left: 36px;
  ${({ scroll }) =>
    scroll &&
    `
    overflow-y: scroll;
    max-height: 480px;
    scrollbar-width: none; 
    -ms-overflow-style: none; 
    &::-webkit-scrollbar {
      display: none; 
    }

    /* Efecto de transición */
    transition: background-color 0.3s;
  `};

`;

export const ScrollUpButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.disabled
      ? "var(--color-grey65)"
      : props.opcDelete
      ? "var(--color-primary)"
      : "var(--color-latex30)"};
  cursor: pointer;
  color: var(--color-white);
  font-size: 24px;
  border-radius: 50%;
  width: 52px;
  height: 52px;
  transform: rotate(-90deg);
`;
export const ScrollDownButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.disabled
      ? "var(--color-grey65)"
      : props.opcDelete
      ? "var(--color-primary)"
      : "var(--color-latex30)"};
  cursor: pointer;
  color: var(--color-white);
  font-size: 24px;
  border-radius: 50%;
  width: 52px;
  height: 52px;
  transform: rotate(90deg);
`;

export const FiltroCascadaFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 32px;
  padding-top: 24px;
`;
export const FiltroCascadaBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 132px;
  height: 36px;
  border-radius: 8px;
  background-color: var(--color-broccoli);
  color: var(--color-white);
`;
export const FiltroCascadaBtnDanger = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 132px;
  height: 36px;
  border-radius: 8px;
  background-color: var(--color-danger);
  color: var(--color-white);
`;
